import auth from 'b2b-common/services/auth'

import privateView from './index'

import accountView from './account'
import tourViews from './tour/router'
import bookingViews from './bookings/router'

export default {
  path: 'private',
  name: 'Private/Default',
  component: privateView,
  redirect: { name: 'Private/Tour' },
  beforeEnter: (to, from, next) => {
    auth.isLoggedIn().then((isLoggedIn) => {
      if (isLoggedIn) next()
      else next({ name: 'Public/Default' })
    }, () => {
      next({ name: 'Public/Default' })
    })
  },
  children: [
    tourViews,
    bookingViews,
    {
      path: 'cont',
      name: 'Private/Account',
      component: accountView
    },
    {
      path: 'logout',
      name: 'Private/Logout',
      beforeEnter: (to, from, next) => {
        auth.logout()
          .then(() => {
            // TODO: inform of succcesful logout
            next({ name: 'Public/Default' })
          })
          .catch(() => {
            // TODO: inform user about problem
            next({ name: 'Private/Default' })
          })
      }
    }
  ]
}
